import * as actionTypes from './actionTypes';
import { Client } from '../types/Client';
import clientServices from '../services/userServices';

export const getClients = (payload: any) => {
  return {
    type: actionTypes.GET_CLIENTS_REQUEST,
    payload: payload,
  };
};

export const getMasterClients = (payload: any) => {
  return {
    type: actionTypes.GET_MASTER_CLIENTS_REQUEST,
    payload: payload
  }
}

export const getClientsWithoutPagination = (payload: any) => {
  return {
    type: actionTypes.GET_CLIENTS_WITHOUT_PAGINATION_REQUEST,
    payload: payload,
  };
};

export const getRolesListWithoutPagination = (payload: any) => {
  return {
    type: actionTypes.GET_ROLES_WITHOUT_PAGINATION_REQUEST,
    payload: payload,
  };
};

export const getRolesList = (payload: any) => {
  return {
    type: actionTypes.GET_ROLES_LIST,
    payload: payload,
  };
};
export const getDefaultRolesList = (payload: any) => {
  return {
    type: actionTypes.GET_DEFAULT_ROLES_LIST,
    payload: payload,
  };
};
export const getNextClientPage = (payload: any) => {
  return {
    type: actionTypes.GET_NEXT_CLIENT_PAGE,
    payload: payload,
  };
};

export const getPrevClientPage = (payload: any) => {
  return {
    type: actionTypes.GET_PREV_CLIENT_PAGE,
    payload: payload,
  };
};

export const getNextRolePage = (payload: any) => {
  return {
    type: actionTypes.GET_NEXT_ROLE_PAGE,
    payload: payload,
  };
};

export const getPrevRolePage = (payload: any) => {
  return {
    type: actionTypes.GET_PREV_ROLE_PAGE,
    payload: payload,
  };
};
export const addRole = (payload: any) => {
  return {
    type: actionTypes.ADD_ROLE,
    payload: payload
  }
}
export const addUser = (payload: any) => {
  return {
    type: actionTypes.ADD_USER,
    payload: payload
  }
}
export const getFirstClientPage = () => {
  return {
    type: actionTypes.GET_FIRST_CLIENT_PAGE,
    payload: 1,
  };
};

export const getLastClientPage = () => {
  return {
    type: actionTypes.GET_LAST_CLIENT_PAGE,
  };
};

export const isLoadingTrue = () => {
  return {
    type: actionTypes.IS_LOADING_TRUE
  };
};
export const isLoadingFalse = () => {
  return {
    type: actionTypes.IS_LOADING_FALSE
  };
};


export const addClient = (client: Client) => {
  return {
    type: actionTypes.ADD_CLIENT,
    payload: client,
  };
};
export const addClientToastClose = () => {
  return {
    type: actionTypes.ADD_CLIENT_TOAST_CLOSE
  };
};

export const addPropToToastClose = () => {
  return {
    type: actionTypes.ADD_ROLE_TOAST_CLOSE
  }
}
export const addUserToastClose = () => {
  return {
    type: actionTypes.ADD_USER_TOAST_CLOSE
  }
}

export const addClientCorrection = () => {
  return {
    type: actionTypes.ADD_CLIENT_CORRECTION
  };
};

export const editRole = (role: any) => {
  return {
    type: actionTypes.EDIT_ROLE,
    payload: role,
  };
};
export const editUser = (user: any) => {
  return {
    type: actionTypes.EDIT_USER,
    payload: user,
  };
};
export const getRoleById = (role: any) => {
  return {
    type: actionTypes.GET_ROLE,
    payload: role,
  };
};

export const getUserById= (user: any) => {
  return {
    type: actionTypes.GET_USER,
    payload: user,
  };
};

export const checkIfClientExists = (clientOrOrgName: any) => {
  return {
    type: actionTypes.CHECK_IF_CLIENT_EXISTS,
    payload: clientOrOrgName,
  };
};

export const editClient = (client: Client) => {
  return {
    type: actionTypes.EDIT_CLIENT,
    payload: client,
  };
};
export const editClientToastClose = () => {
  return {
    type: actionTypes.EDIT_CLIENT_TOAST_CLOSE,
  };
};
export const editClientCorrection = () => {
  return {
    type: actionTypes.EDIT_CLIENT_CORRECTION,
  };
};

export const getClient = (id: any) => {
  return {
    type: actionTypes.GET_CLIENT,
    payload: id,
  };
};

export const showLicenseExpiredDialog = (configureDialog: any) => {
  return {
    type: actionTypes.SHOW_LICENSE_EXPIRED_DIALOG,
    payload: configureDialog,
  };
};

export const showModuleAccessDialog = (configureDialog: any) => {
  return {
    type: actionTypes.SHOW_MODULE_ACCESS_DIALOG,
    payload: configureDialog,
  };
};

export const showErrorMessageToast = (msg: any) => {
  return {
    type: actionTypes.SHOW_ERROR_MESSAGE_TOAST,
    payload: msg,
  };
};


export const getUsers = (payload: any) => {
  return {
    type: actionTypes.GET_USERS_REQUEST,
    payload: payload,
  };
};

export const getSubjectList = (payload: any) => {
  return {
    type: actionTypes.GET_SUBJECT_LIST,
    payload: payload,
  };
};
export const getCourseList = (payload: any) => {
  return {
    type: actionTypes.GET_COURSE_LIST,
    payload: payload,
  };
};
export const setBulkImportTest = (payload: any) => {
  return {
    type: actionTypes.SET_BULK_IMPORT_TEST,
    payload: payload,
  };
};
export const switchSelectedTab = (payload: any) => {
  return {
    type: actionTypes.SWITCH_SELECTED_TAB,
    payload: payload
  }
}

export const setRolesTab = (payload: any) => {
  return {
    type: actionTypes.SET_ROLES_TAB,
    payload: payload
  }
}

export const setUsersTab = (payload: any) => {
  return {
    type: actionTypes.SET_USERS_TAB,
    payload: payload
  }
}

export const setClientTab = (payload: any) => {
  return {
    type: actionTypes.SET_CLIENTS_TAB,
    payload: payload
  }
}

export const searchUserMgmt = (payload: any) => {
  return {
    type: actionTypes.SEARCH_USER_MANAGMENT,
    payload: payload
  }
}

export const setPaginationToFirstPage = () => {
  return {
    type: actionTypes.SET_PAGINATION_TO_PAGE_ONE
  }
}

export const resetPaginationToNull = () => {
  return {
    type: actionTypes.RESET_PAGE_NUMBER_TO_NULL
  }
}

export const addRoleChip = (payload: any) => {
  return {
    type: actionTypes.ADD_ROLE_CHIP,
    payload: payload
  }
}

export const removeRoleChip = (payload: any) => {
  return {
    type: actionTypes.REMOVE_ROLE_CHIP,
    payload: payload
  }
}

export const addUsersSearchChip = (payload: any) => {
  return {
    type: actionTypes.ADD_USERS_CHIP,
    payload: payload
  }
}

export const removeUsersSearchChip = (payload: any) =>{
  return {
    type: actionTypes.REMOVE_USERS_CHIP,
    payload: payload
  }
}

export const clearChips = () => {
  return {
    type: actionTypes.CLEAR_CHIPS
  }
}

export const setRolesSearchActiveOption = (payload: any) => {
  return {
    type: actionTypes.SET_ROLES_SEARCH_ACTIVE_OPTION,
    payload: payload
  }
}

export const setUsersSearchActiveOption = (payload: any) => {
  return {
    type: actionTypes.SET_USERS_SEARCH_ACTIVE_OPTION,
    payload: payload,
  }
}

export const setSearchQueryByTab = (payload: any) => {
  return {
    type: actionTypes.SET_SEARCH_QUERY_BY_TAB,
    payload: payload
  }
}

export const clearSearchQueryText = () => {
  return {
    type: actionTypes.CLEAR_SEARCH_QUERY_TEXT
  }
}


